// General
import "./verified-photo-element.scss";
import { useEffect } from "react";
// Services
import { useLazyGetProfileQuery } from "../../../services/data.service";
// Static Data
import routeConst from "../../../const/routeConst";
// Redux
import { useDispatch } from "react-redux";
import { updateInterestTab } from "../../../redux/store/interestStore";
import {
  updateNotificationIsSeen,
  updateShowNotificationBadge,

  // Utility Functions
  updateCloseNotificationTabPassthrough,
} from "../../../redux/store/notificationStore";
// Material UI
import { ButtonBase } from "@mui/material";
// i18next
import { useTranslation } from "react-i18next";
// Custom Hooks
import useCustomNavigate from "../../utility/custom-hooks/useCustomNavigate-hook";
import IconManager from "../../utility/manager/icon-manager/icon-manager";

const VerifiedPhotoElement = (props) => {
  const { notificationId, message, isApproved, timestamp, isSeen } = props;

  // API variables
  const [
    getProfile,
    {
      data: getProfileData,
      error: getProfileErrorData,
      isFetching: getProfileFetching,
      isLoading: getProfileLoading,
      isSuccess: getProfileSuccess,
      isError: getProfileError,
    },
  ] = useLazyGetProfileQuery();

  // Redux variables
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();
  const getIcon = IconManager();

  // Lifecycle | Mounted
  useEffect(() => {
    getProfile(null, true);
  }, []);

  // Event Handlers | Button
  const onCheckStatus = () => {
    markAsSeen();
    onCloseNotificationTab();
  };
  const onCheck = () => {
    onNavigate(
      isApproved
        ? routeConst.verify.sugarbookVerified.status.approved.path
        : routeConst.verify.sugarbookVerified.photoMatching.rejected.path
    );
  };
  const onEditProfile = () => {
    onNavigate(routeConst.profile.edit.path);
  };

  // Utility Functions
  const markAsSeen = () => {
    const obj = {
      notificationId,
      isSeen: true,
    };
    dispatch(updateNotificationIsSeen(obj));
    setTimeout(() => {
      dispatch(updateShowNotificationBadge());
    }, 1000);
  };
  const onCloseNotificationTab = () => {
    dispatch(updateCloseNotificationTabPassthrough());
  };

  return (
    <div
      id="notification-verified-photo-element-subcomponent"
      className={isSeen ? "" : "notification-unseen"}
      onClick={onCheckStatus}
    >
      <div className="verified-icon-container">
        {getIcon(
          `${isApproved ? "verifiedProfileBadge" : "unverifiedProfileBadge"}`,
          "verified-icon"
        )}
      </div>

      <div className="verified-photo-body-container">
        {message} <span className="timestamp">{timestamp}</span>
      </div>

      {!isApproved && getProfileData?.data?.vp3?.pending_photo && (
        <div className="button-container">
          <ButtonBase className="check-button" onClick={onCheck}>
            {t("common.check")}
          </ButtonBase>
        </div>
      )}

      {isApproved && getProfileData?.data?.vp3?.status === "approved" && (
        <div className="button-container">
          <ButtonBase className="check-button" onClick={onEditProfile}>
            {t("common.check")}
          </ButtonBase>
        </div>
      )}
    </div>
  );
};

export default VerifiedPhotoElement;
